var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"head"},[_c('h1',[_vm._v(_vm._s(_vm.$t('cross_chain.title')))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('cross_chain.desc'))+" ")])]),_c('ChainTransfer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }